export default __webpack_public_path__ + "static/media/ali.6d1e095d.png";